import componentRegistration from "flow/filter/FilterContainerComponent/componentRegistration";
import dateBindingV2 from "flow/bindings/dateBindingV2";
import endDateBinding from "flow/bindings/endDateBinding";
import noFutureDate from "flow/validation/noFutureDate";
import koPersonId from "flow/validation/koPersonId";
import MyFlow from "flow/MyFlow";

function load(myFlow: MyFlow, returnValueFromPreviousStep: boolean): JQueryPromise<boolean> {
    const dfd = myFlow.deferred<boolean>();

    componentRegistration.setup();
    dateBindingV2.setup();
    endDateBinding.setup();
    noFutureDate.setup();
    koPersonId.setup();

    return dfd.resolve(returnValueFromPreviousStep).promise();
}

export default {
    load
};
